import http from '@/http'
const URL = '/admin/users'

export const list = async (params) => {
  const list = (await http.get(URL, { params: params }))
  return list
}

export const show = async (id) => {
  let one = null
  if (id) {
    one = (await http.get(URL + `/${id}?include=rooms`))
  }
  return one
}

export const getFormFields = async (formId = null) => {
  // If no formId provided, get the first active form
  if (!formId) {
    const formsRes = await http.get('/admin/event-forms?limit=1&status=1')
    const forms = formsRes.data?.data || []
    if (forms.length > 0) {
      formId = forms[0].id
    }
  }
  if (!formId) {
    return { data: { data: [] } }
  }
  return http.get(`/admin/event-forms/${formId}/fields`)
}

export const saveUser = (payload) => {
  if (payload.id) {
    return http.put(URL + `/${payload.id}`, payload)
  }
  return http.post(URL, payload)
}

export const importUsers = (payload) => {
  return http.post(URL + '/import', payload, { headers: { 'Content-Type': 'multipart/form-data' } })
}

export const changeStatus = (payload) => http.put(URL + `/${payload}/status`)

export const changeModerator = (payload) => http.put(URL + `/${payload}/moderator`)

export const deleteUser = async (id) => http.delete(URL + `/${id}`)

export const exportData = async (params) => {
  const data = (await http.get(URL + '/export', { params: params, responseType: 'blob' }))
  return data
}

export default {
  list,
  show,
  saveUser,
  importUsers,
  changeStatus,
  deleteUser,
  exportData,
  changeModerator,
  getFormFields
}
